<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="row d-flex mx-2"
                        @submit.prevent="submit">
        <div class="col-sm-6 py-4">
            <ValidationProvider tag="div"
                                vid="jobTitle"
                                class="mb-4"
                                mode="lazy"
                                rules="required"
                                :customMessages="{required: 'Norādi amata nosaukumu.'}"
                                v-slot="{errors}">
                <label for="jobTitleName" class="d-block text-secondary text-left mb-0">Amata nosaukums</label>
                <input type="text" id="jobTitleName" class="w-100 py-1 ds-input" v-model="jobTitle.name">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider tag="div"
                                vid="jobTitleSubName"
                                class="mb-4"
                                mode="lazy"
                                v-slot="{errors}">
                <label for="jobTitleSubName" class="d-block text-secondary text-left mb-0">Amata apakšnosaukums</label>
                <input type="text" id="jobTitleSubName" class="w-100 py-1 ds-input" v-model="jobTitle.subName">
                <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
        <CustomButton class="w-25 mb-4 ds-btn--success" :btn-text="jobTitle._id ? 'Saglabāt izmaiņas' : 'Pievienot'"
                      :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex';

    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import * as jobTitleStoreTypes from '../../vuex/modules/company/modules/job-titles/job-title.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import {JobTitle} from "../../vuex/modules/company/modules/job-titles/job-title.models";

    export default {
        name: 'job-title-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                jobTitle: {...this.$store.state.jobTitle.selectedJobTitle},
            }
        },
        created() {
            extend('required', required);
        },
        computed: {
            ...mapGetters('jobTitle', {
                /** @type {boolean|*} */
                isActiveRequest: jobTitleStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('jobTitle', {
                /** @type {function|*} */
                addJobTitle: jobTitleStoreTypes.ACTION_ADD_JOB_TITLE,
                /** @type {function|*} */
                updateJobTitle: jobTitleStoreTypes.ACTION_UPDATE_JOB_TITLE,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    if (this.jobTitle._id) {
                        await this.updateJobTitle({companyId: this.$route.params.companyId, jobTitle: this.jobTitle});
                        this.reset();
                        return this.setAlertData({type: 'primary', message: 'Amata izmaiņas saglabātas!'});
                    }

                    await this.addJobTitle({companyId: this.$route.params.companyId, jobTitle: this.jobTitle});
                    this.setAlertData({type: 'primary', message: 'Amats pievienots!'});
                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            reset() {
                this.jobTitle = new JobTitle();
                this.$refs.observer.reset();
                this.$emit('finished');
            },
        },
    }
</script>